const getDataSavingMode = () => !!navigator?.connection?.saveData;

export default getDataSavingMode;
